var map = {
	"./home/home.module": [
		"./src/app/home/home.module.ts",
		"default~home-home-module~patient-patient-module~recent-studies-recent-studies-module~search-search-module",
		"default~home-home-module~patient-patient-module",
		"home-home-module"
	],
	"./patient/patient.module": [
		"./src/app/home/patient/patient.module.ts",
		"default~home-home-module~patient-patient-module~recent-studies-recent-studies-module~search-search-module",
		"default~home-home-module~patient-patient-module",
		"patient-patient-module"
	],
	"./recent-studies/recent-studies.module": [
		"./src/app/recent-studies/recent-studies.module.ts",
		"default~home-home-module~patient-patient-module~recent-studies-recent-studies-module~search-search-module",
		"recent-studies-recent-studies-module"
	],
	"./search/search.module": [
		"./src/app/search/search.module.ts",
		"default~home-home-module~patient-patient-module~recent-studies-recent-studies-module~search-search-module",
		"search-search-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;